/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const CssPreviewIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="CssPreviewIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M6 3H5.5C4.67157 3 4 3.67157 4 4.5V6C4 6.8178 3.60733 7.54389 3.00024 8C3.60733 8.45612 4 9.1822 4 10V11.5C4 12.3284 4.67157 13 5.5 13H6V14H5.5C4.11929 14 3 12.8807 3 11.5V10C3 9.17157 2.32843 8.5 1.5 8.5H1V7.5H1.5C2.32843 7.5 3 6.82843 3 6V4.5C3 3.11929 4.11929 2 5.5 2H6V3Z"
                fill="currentColor"
              />
              <path
                d="M10 3H10.5C11.3284 3 12 3.67157 12 4.5V6C12 6.8178 12.3927 7.54389 12.9998 8C12.3927 8.45612 12 9.1822 12 10V11.5C12 12.3284 11.3284 13 10.5 13H10V14H10.5C11.8807 14 13 12.8807 13 11.5V10C13 9.17157 13.6716 8.5 14.5 8.5H15V7.5H14.5C13.6716 7.5 13 6.82843 13 6V4.5C13 3.11929 11.8807 2 10.5 2H10V3Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

CssPreviewIcon.tags = ['code', 'stylesheet', 'syntax', 'brackets'];

CssPreviewIcon.category = 'General Icons';

CssPreviewIcon.iconSize = 16;
